import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { FormStatusEnum } from "app/services/api/types/forms/enums/FormStatusEnums";
import { Button, ButtonText } from "ui/gluestack/button";
import { useAssessmentEntryEdit } from "app/features/assessments/providers";

interface Props {
  entry: SubmittedFormModel;
}

export function AssessmentEntryEditAction({ entry }: Props) {
  const { openEditModal } = useAssessmentEntryEdit();

  if (entry.status !== FormStatusEnum.DRAFT) return null;

  return (
    <Button action="secondary" onPress={() => openEditModal(entry)}>
      <ButtonText>Continue editing</ButtonText>
    </Button>
  );
}
